module.exports = __webpack_public_path__ + "img/item-1.33a67292.jpeg";